/** The view registry: a route resolves to a view factory, an unknown route fails closed. */
import type { Route } from "../app/router.ts";
import type { ViewContext, ViewFactory, ViewHandle } from "../app/view.ts";
import { resolveOrders, resolvePortfolio } from "./account/routes.ts";
import { mountBoard } from "./board/index.ts";
import { mountDetail } from "./detail/index.ts";
import { mountScanner } from "./scanner/index.ts";
import { resolveOps } from "./ops-routes.ts";
import { mountNotFound, mountOpportunities, mountStub } from "./stubs.ts";
import { resolveSettings } from "./delivery/routes.ts";
import { resolveRouting } from "./routing/index.ts";
import { mountTrackb } from "./trackb/index.ts";
import { mountToday } from "./today/index.ts";

/** Resolve the view for a route. */
export function resolveView(route: Route): ViewFactory {
  const ops = resolveOps(route);
  if (ops !== null) {
    return ops;
  }
  switch (route.area) {
    case "today":
      return mountToday;
    case "opportunities":
      return opportunities(route);
    case "settings":
      return resolveSettings(route);
    case "portfolio":
      return resolvePortfolio(route);
    case "orders":
      return resolveRouting(route) ?? resolveOrders();
    case "watchlists":
    case "research":
    case "data":
    case "operations":
    case "security": {
      const area = route.area;
      return (ctx: ViewContext): ViewHandle => mountStub(ctx, area);
    }
  }
}

function opportunities(route: Route): ViewFactory {
  switch (route.sub) {
    case null:
      return mountOpportunities;
    case "scanner":
      return mountScanner;
    case "board":
      return mountBoard;
    case "trackb":
      return mountTrackb;
    case "detail":
      return (ctx) => mountDetail(ctx);
    default:
      return mountNotFound;
  }
}
